import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/password_ic_tip@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-51959a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password_tip" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "密码由6-20个英文字母、数字或符号组成")
], -1))
const _hoisted_3 = { class: "password_list" }
const _hoisted_4 = { class: "password_list_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原密码", -1))
const _hoisted_6 = { class: "password_list_item_box" }
const _hoisted_7 = { class: "password_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新密码", -1))
const _hoisted_9 = { class: "password_list_item_box" }
const _hoisted_10 = { class: "password_list_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认密码", -1))
const _hoisted_12 = { class: "password_list_item_box" }
const _hoisted_13 = { class: "password_footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "完成", -1))
const _hoisted_15 = [
  _hoisted_14
]

import { reactive } from 'vue'
    import { Toast } from 'vant'
    import { useRouter } from "vue-router"
    import { updatePwd } from '@/apis/PersonalAPI'
    import { passwordVerification } from '@/interface'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    let form = reactive<passwordVerification>({
        originalPassword: '',
        newPassword: '',
        confirmPassword: ''
    })

    const forgotPassword = (): void => {

    }

    const submit = (): void => {
        if (!form.originalPassword) {
            Toast({ message: '原密码不能为空' })
        } else if (!form.newPassword) {
            Toast({ message: '新密码不能为空' })
        } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/.test(form.newPassword)) {
            Toast({ message: '密码格式不正确' })
        } else if (!form.confirmPassword) {
            Toast({ message: '确认密码不能为空' })
        } else if (form.newPassword !== form.confirmPassword) {
            Toast({ message: '两次输入的密码不一致' })
        } else {
            updatePwd({
                newPwd: form.newPassword,
                oldPwd: form.originalPassword
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '修改成功', duration: 2000, forbidClick: true })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
        }
    }

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).originalPassword) = $event)),
            maxlength: "20",
            placeholder: "请输入原密码"
          }, null, 512), [
            [_vModelText, _unref(form).originalPassword]
          ]),
          _createElementVNode("p", { onClick: forgotPassword }, "忘记密码")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).newPassword) = $event)),
            maxlength: "20",
            placeholder: "请输入新密码"
          }, null, 512), [
            [_vModelText, _unref(form).newPassword]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).confirmPassword) = $event)),
            maxlength: "20",
            placeholder: "再次输入新密码"
          }, null, 512), [
            [_vModelText, _unref(form).confirmPassword]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "password_footer_submit",
        onClick: submit
      }, _hoisted_15)), [
        [_directive_preventReClick]
      ])
    ])
  ]))
}
}

})